import { updateWindow } from "mirador/dist/es/src/state/actions";
import { getContainerId } from "mirador/dist/es/src/state/selectors";
import { getCanvases, getCanvasLabel, getVisibleCanvases, selectInfoResponse } from "mirador/dist/es/src/state/selectors/canvases";
import { getManifestRelatedContent, getManifestUrl } from "mirador/dist/es/src/state/selectors/manifests";
import downloadDialogComponents, { getPluginConfig } from "mirador-downloaddialog";
import PdfDafoDownloadDialog from "./components/PdfDafoDownloadDialog";
import translations from "./locales";
var otherComponents = downloadDialogComponents.filter(function (c) {
  return c.name !== "DownloadDialog";
});
export default [].concat(otherComponents, [{
  component: PdfDafoDownloadDialog,
  config: {
    translations: translations
  },
  mapDispatchToProps: function mapDispatchToProps(dispatch, _ref) {
    var windowId = _ref.windowId;
    return {
      updateConfig: function updateConfig(downloadDialog) {
        return dispatch(updateWindow(windowId, {
          downloadDialog: downloadDialog
        }));
      }
    };
  },
  mapStateToProps: function mapStateToProps(state, _ref2) {
    var windowId = _ref2.windowId;
    return {
      canvases: getCanvases(state, {
        windowId: windowId
      }),
      canvasLabel: function canvasLabel(canvasId) {
        return getCanvasLabel(state, {
          canvasId: canvasId,
          windowId: windowId
        });
      },
      config: getPluginConfig(state, {
        windowId: windowId
      }),
      containerId: getContainerId(state),
      infoResponse: function infoResponse(canvasId) {
        var _selectInfoResponse;
        return (_selectInfoResponse = selectInfoResponse(state, {
          canvasId: canvasId,
          windowId: windowId
        })) !== null && _selectInfoResponse !== void 0 ? _selectInfoResponse : {};
      },
      manifestUrl: getManifestUrl(state, {
        windowId: windowId
      }),
      seeAlso: getManifestRelatedContent(state, {
        windowId: windowId
      }),
      visibleCanvases: getVisibleCanvases(state, {
        windowId: windowId
      })
    };
  },
  mode: "add",
  name: "PdfDafoDownloadDialog",
  target: "Window"
}]);